/**
 * @generated SignedSource<<d6992bd9610df4651de8880c883bc222>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraComponentsField$data = {
  readonly components: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly componentId: string;
        readonly name: string | null;
      } | null;
    } | null> | null;
  } | null;
  readonly fieldConfig: {
    readonly isEditable: boolean | null;
    readonly isRequired: boolean | null;
  } | null;
  readonly name: string;
  readonly " $fragmentType": "JiraComponentsField";
};
export type JiraComponentsField$key = {
  readonly " $data"?: JiraComponentsField$data;
  readonly " $fragmentSpreads": FragmentRefs<"JiraComponentsField">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "name"
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "JiraComponentsField",
  "selections": [
    (v0/*: any*/),
    {
      "concreteType": "JiraFieldConfig",
      "kind": "LinkedField",
      "name": "fieldConfig",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "isRequired"
        },
        {
          "kind": "ScalarField",
          "name": "isEditable"
        }
      ]
    },
    {
      "concreteType": "JiraComponentConnection",
      "kind": "LinkedField",
      "name": "components",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraComponentEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraComponent",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "componentId"
                },
                (v0/*: any*/)
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraComponentsField"
};
})();

(node as any).hash = "5e97da6f23797a48e135e5fe767dafc6";

export default node;
